import React, { useEffect, useState } from 'react';
import Cta from '../Cta';
import Div from '../Div';
import LogoList from '../LogoList';
import MovingText from '../MovingText';
import Portfolio2 from '../Portfolio/Portfolio2';
import Portfolio3 from '../Portfolio/Portfolio3';
import TestimonialSlider from '../Slider/TestimonialSlider';
import Spacing from '../Spacing';
import { pageTitle } from '../../helper';

const heroSocialLinks = [
  { name: 'Instagram', links: 'https://www.instagram.com/voxmotionco/' },
  { name: 'LinkedIn', links: 'https://www.linkedin.com/company/vox-motion' },
];

// Helper to convert YouTube URLs to embed format
function getEmbedUrl(url) {
  if (url.includes('youtube.com/watch?v=')) {
    const id = url.split('v=')[1].split('&')[0];
    return `https://www.youtube.com/embed/${id}`;
  }
  if (url.includes('youtu.be/')) {
    const id = url.split('youtu.be/')[1].split('?')[0];
    return `https://www.youtube.com/embed/${id}`;
  }
  return url;
}

const portfolioData = [
  {
    title: 'How a tech founder’s vision reshaped real-world business outcomes',
    subtitle: 'Translating vision into value',
    btnText: 'Watch Showcase',
    btnLink: 'https://youtu.be/Q46TLKgeA-c',
    imageUrl: '/images/portfoliopage1.jpg',
    category: 'Brand Insight',
  },
  {
    title: 'How a Georgia realtor builds credibility with location-led storytelling',
    subtitle: 'Local knowledge, globally told',
    btnText: 'Watch Showcase',
    btnLink: 'https://youtu.be/ZdQU8L7Tk_Q',
    imageUrl: '/images/portfoliopage2.jpg',
    category: 'Market Voice',
  },
  {
    title: 'Reframing global conflict through editorial storytelling with mass appeal',
    subtitle: 'Geopolitics, reframed through story',
    btnText: 'Watch Showcase',
    btnLink: 'https://www.youtube.com/watch?v=rWTit0VMJp0&list=LL&index=2',
    imageUrl: '/images/portfoliopage3.jpg',
    category: 'Global Feature',
  },
  {
    title: 'An award-winning ballet dancer’s raw journey from injury to reinvention',
    subtitle: 'Where art and resilience move together',
    btnText: 'Watch Showcase',
    btnLink: 'https://youtu.be/XdTfaS49zbw',
    imageUrl: '/images/portfoliopage4.jpg',
    category: 'Motion Journal',
  },
];

// Simple Video Modal component
function VideoModal({ open, onClose, videoUrl }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 9999,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{ position: 'relative', width: '90vw', maxWidth: 800, background: 'transparent' }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: -40,
            right: 0,
            background: 'transparent',
            border: 'none',
            color: '#fff',
            fontSize: 32,
            cursor: 'pointer',
          }}
          aria-label="Close"
        >
          &times;
        </button>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          <iframe
            src={getEmbedUrl(videoUrl)}
            title="Portfolio Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: 8,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default function CreativePortfolioHome() {
  pageTitle('Creative Portfolio');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalVideo, setModalVideo] = useState('');

  const handleOpenModal = (videoUrl) => {
    setModalVideo(videoUrl);
    setModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setModalOpen(false);
    setModalVideo('');
  };

  return (
    <>
      {/* Start Hero Section */}
        title="Selected Stories<br />In Motion"
        btnLink="/contact"
        btnText={`Let's talk`}
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="./images/hero_bg_4.jpeg"
      />
      {/* End Hero Section */}

      {/* Start Portfolio Section */}
      <Spacing lg="150" md="80" />
      {portfolioData.map((item, index) =>
        index % 2 === 0 ? (
          <Div key={index}>
            <Portfolio2
              title={item.title}
              subtitle={item.subtitle}
              btnText={item.btnText}
              btnLink="#"
              onBtnClick={() => handleOpenModal(item.btnLink)}
              imageUrl={item.imageUrl}
              category={item.category}
            />
            <Spacing lg="100" md="70" />
          </Div>
        ) : (
          <Div key={index}>
            <Portfolio3
              title={item.title}
              subtitle={item.subtitle}
              btnText={item.btnText}
              btnLink="#"
              onBtnClick={() => handleOpenModal(item.btnLink)}
              imageUrl={item.imageUrl}
              category={item.category}
            />
            <Spacing lg="100" md="70" />
          </Div>
        ),
      )}
      {/* End Portfolio Section */}

      {/* Video Modal */}
      <VideoModal open={modalOpen} onClose={handleCloseModal} videoUrl={modalVideo} />

      {/* Start Testimonial Section */}
      <TestimonialSlider />
      {/* End Testimonial Section */}

      {/* Start MovingText Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="Our reputed world wide partners" />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Let’s discuss and make <br />something <i>cool</i> together"
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg_3.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}